export const FULFILLED = 'fulfilled';